"use strict";
require('../company/publications/CompanyPublicationFileService.js');
function GuestPublicationImageDirective(CompanyPublicationFileService) {
  return {
    restrict: 'EA',
    link: function($scope, $elem) {
      CompanyPublicationFileService.query({companyId: $scope.companyId, publicationId: $scope.publication.id}).$promise.then(function(resp){
        if (resp.length > 0) {
          var fileId = resp[0].id;
          CompanyPublicationFileService.getPreview({companyId: $scope.companyId, publicationId: $scope.publication.id, fileId: fileId}, function(data) {
            $elem.attr('src', 'data:' + data.dataUrl + '');
          });
        }
      });
    }

  };
}
angular.module('dokiv')
  .directive('guestPublicationImage', ['CompanyPublicationFileService', GuestPublicationImageDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/GuestPublicationImageDirective.js
// module id = 282
// module chunks = 0